import { render, staticRenderFns } from "./noticeInfo.vue?vue&type=template&id=21c7de6e&"
import script from "./noticeInfo.vue?vue&type=script&lang=js&"
export * from "./noticeInfo.vue?vue&type=script&lang=js&"
import style0 from "./noticeInfo.vue?vue&type=style&index=0&id=21c7de6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports